import CityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { greshamConfig } from "./data";

export default function GreshamPage() {
  return <CityPageTemplate config={greshamConfig} />;
}